module.exports = __webpack_public_path__ + "static/media/9.29a7f7bc.png";